var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-page',[_c('page-image',{attrs:{"imgURL":require('@/assets/img/hero03.jpg'),"title":"Recipe","subTitle":"レシピ","fontSize":"6rem"}}),_c('section-frame',[_vm._v(" Comming Soon... ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }